import React, { Component, FormEvent } from 'react'
import { Form, Button, Alert } from 'antd'
import CustomerSurveyFields from './CustomerSurveyFields'
import {
  getStores,
  generateFormFieldValuesArray,
  postFormSubmission
} from './lib/apiUtils'
import * as config from './config'
import './CustomerSurvey.css'
import {FormFieldProperties, Store, IndexableAssocObject, FormValues} from './types'
import { FormComponentProps } from 'antd/lib/form'
import {FORM_ID} from "./config";

export interface CustomerSurveyProperties extends FormComponentProps {
}
export interface CustomerSurveyState {
  loading: boolean
  error: any
  submitted: boolean
  stores: [Store]|[]
  values: FormValues
}

class CustomerSurvey extends Component<CustomerSurveyProperties, CustomerSurveyState> {
  constructor (props:CustomerSurveyProperties) {
    super(props)
    this.state = {
      loading: false,
      error: null,
      submitted: false,
      stores: [],
      // @ts-ignore
      values: {}
    }
  }

  componentDidMount = async () => {
    const storesResponse = await getStores()
    if (storesResponse instanceof Error || storesResponse.error != null) {
      this.handleError(storesResponse)
    } else {
      this.setState({
        stores: storesResponse
      })
    }
  }

  handleFieldChange = (name:string|String[], value:any) => {
    if (typeof name === 'string') {
      this.setState({
        values: {
          ...this.state.values,
          [name]: value
        }
      })
    } else {
      let values = {}
      name.forEach((field) => {
        // @ts-ignore
        values[field] = value
      })
      // @ts-ignore
      this.setState({values})
    }
  }

  handleSubmit = (e:FormEvent) => {
    const { form } = this.props
    this.setState({ loading: false })
    e.preventDefault()
    form.validateFieldsAndScroll(async (error, values) => {
      if (!error) {
        this.setState({
          loading: true
        })
          const formFieldValues = await generateFormFieldValuesArray(CustomerSurveyFields, values)
          try {
            await postFormSubmission(FORM_ID, formFieldValues)
            this.setState({
              submitted: true,
              loading: false
            })
          } catch (error) {
            this.handleError(error)
          }
      }
    })
  }

  handleError = (error: any) => {
    console.error({ error })
    this.setState({
      loading: false,
      error: true,
      submitted: false
    })
  }

  render () {
    const { form } = this.props
    const { loading, error, submitted, stores, values } = this.state
    const submitText = (loading) ? config.BUTTON_SUBMIT_LOADING_TEXT : config.BUTTON_SUBMIT_IDLE_TEXT
    const PostFailedAlert = () => (
      <Alert
        message={config.ALERT_ERROR_HEADING}
        description={config.ALERT_ERROR_BODY}
        type='error'
        style={{ marginBottom: 20 }}
      />
    )

    const PostSuccessAlert = () => {
      let description = (this.state.values.followupRequested != null && this.state.values.followupRequested) ? config.ALERT_SUCCESS_BODY_RESPONSE_REQUESTED : config.ALERT_SUCCESS_BODY
      return (
      <Alert
          message={config.ALERT_SUCCESS_HEADING}
          description={description}
          type='success'
      />
      )
    }

    return (
      <div className='customerSurvey'>
        {!submitted &&
        <Form onSubmit={this.handleSubmit} layout='vertical'>
          {CustomerSurveyFields.map((field, key) => {
            const props = { stores, submitted, error, loading, values: { ...values } as IndexableAssocObject } as FormFieldProperties
            if (field.render != null && !field.render(props)) {
              return null
            }
            let decoratorProps = {}
            if (field.rules != null) {
              decoratorProps = { ...decoratorProps, rules: field.rules(props) }
            }
            if (field.initialValue != null) {
              decoratorProps = { ...decoratorProps, initialValue: field.initialValue(props) }
            }
            if (field.valuePropName != null) {
              decoratorProps = { ...decoratorProps, valuePropName: field.valuePropName }
            }
            return (
              <Form.Item key={key} label={field.label}>
                {field.type != null && field.component != null && form.getFieldDecorator(field.name, decoratorProps)(
                  field.component(props, this.handleFieldChange)
                )}
              </Form.Item>
            )
          })}
          {!loading && error != null &&
          <PostFailedAlert />
          }
          <Form.Item>
            <Button type='primary' htmlType='submit'>{submitText}</Button>
          </Form.Item>
        </Form>
        }
        {submitted &&
          <PostSuccessAlert />
        }
      </div>
    )
  }
}

export default Form.create()(CustomerSurvey)
